import { usePromisedRequest } from "../Common/request";

//Source: Joanna\Controller\Api\Fights\FightEstimatedTimeController
export type FightEstimatedTime = {
    totalSecondsToFight: number;
    available: boolean;
    queuePosition: number | null;
    matId: number | null;
    matName: string | null;
    earlyLockOpen: boolean;
    earlyVerificationBlocked: boolean;
    earlyVerificationPeriod: number;
    queueLockOpen: boolean;
    queueVerificationBlocked: boolean;
    queueVerificationLimit: number;
};

export default {
    getFightTimeForEventCompetitor(eventId: number, eventCompetitorId: number): Promise<FightEstimatedTime> {
        return usePromisedRequest<FightEstimatedTime>({
            url: `/api/admin/events/${eventId}/competitors/${eventCompetitorId}/fight-eta`,
            method: "get",
            json: true,
        }).then(res => {
            if (res.statusCode !== 200) {
                throw Error("No fight eta.");
            }
            return res.body;
        });
    },
};
